import React, { useState, useEffect, useContext, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useWindowSize } from '../../hooks/useWindowSize'
// Import des feuilles de styles
import 'antd/dist/antd'
import { observer } from 'mobx-react-lite'
import styles from './Sandbox.module.css'

// Import des composants enfants
import Header from './components/Header/Header'
import Modal from './components/Modal/Modal'
import SidebarEditor from './components/SidebarEditor/SidebarEditor'
import SidebarNav from './components/SidebarNav/SidebarNav'
import DndContextBuilder from './components/DndContextBuilder/DndContextBuilder'
import { WebSocketListener } from './components/webSocket/WebSocketListener'
import { BuilderContext } from './components/store/store.Builder'
import AuthorizationGuard from './components/AuthorizationGuard/AuthorizationGuard'

const Sandbox = observer(() => {
  const renderCountRef = useRef(0)
  renderCountRef.current += 1

  useEffect(() => {
    console.log(`Sandbox render count: ${renderCountRef.current}`)
  })

  const windowSize = useWindowSize()
  const [showModal, setShowModal] = useState(false)

  const builderContext = useContext(BuilderContext)

  const MOBILE_WIDTH_THRESHOLD = 767
  const MOBILE_HEIGHT_THRESHOLD = 500

  useEffect(() => {
    setShowModal(
      windowSize.width < MOBILE_WIDTH_THRESHOLD ||
        windowSize.height < MOBILE_HEIGHT_THRESHOLD
    )
  }, [windowSize])

  return (
    <div
      className={
        builderContext.themeColor === 'Light'
          ? 'light-theme'
          : builderContext.themeColor === 'Dark'
          ? 'dark-theme'
          : ''
      }
    >
      <div className={styles.page}>
        <WebSocketListener />
        <div className={styles.grid}>
          {showModal && (
            <Modal
              windowWidth={windowSize.width}
              windowHeight={windowSize.height}
            />
          )}
          <Header />
          <SidebarNav />
          <DndContextBuilder />
          <SidebarEditor />
        </div>
      </div>
    </div>
  )
})

export default Sandbox
